const s = {
  name: "EmoticonSleep",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M20,2c9.9,0,18,8.1,18,18s-8.1,18-18,18S2,29.9,2,20H0c0,11,9,20,20,20c11,0,20-9,20-20C40,9,31,0,20,0V2z"/>
		<path class="st0" d="M9,10h4.4L9,13.5V16h7v-2h-4.4l4.4-3.5V8H9V10z"/>
		<path class="st0" d="M4.4,2H0V0h7v2.5L2.6,6H7v2H0V5.5L4.4,2z"/>
		<path class="st0" d="M20,28c-2.2,0-4,1.8-4,4c0,2.2,1.8,4,4,4c2.2,0,4-1.8,4-4C24,29.8,22.2,28,20,28z M18,32c0-1.1,0.9-2,2-2
			c1.1,0,2,0.9,2,2c0,1.1-0.9,2-2,2C18.9,34,18,33.1,18,32z"/>
		<path class="st0" d="M10,20c0,1.1,0.9,2,2,2s2-0.9,2-2h2c0,2.2-1.8,4-4,4s-4-1.8-4-4H10z"/>
		<path class="st0" d="M28,22c-1.1,0-2-0.9-2-2h-2c0,2.2,1.8,4,4,4s4-1.8,4-4h-2C30,21.1,29.1,22,28,22z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as EmoticonSleep
};
